var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCircleBold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m3.974 4.96a1 1 0 0 0-1.414 0L6.599 8.918 5.439 7.76l-.093-.083a1 1 0 0 0-1.32 1.497l1.867 1.866.094.083a1 1 0 0 0 1.32-.083l4.667-4.666.083-.094a1 1 0 0 0-.083-1.32"
})));
export default SvgCheckCircleBold;